import React, { useState } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import ConstituentType from '@/constants/ConstituentType';
import translate from '@/lib/intl/translate';
import { ConstituentConnectionTypes, DonorType } from '@/propTypes';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import ConstituentRelationsList from './ConstituentRelationsList';
import MakeConnectionPrimaryContactButton from './MakeConnectionPrimaryContactButton';
import { AddRelationDialog } from './RelationDialogs';

function ConstituentRelationsSection({ constituent, isEditable }) {
  const isOrg = constituent.constituentType === ConstituentType.ORG;
  const [isAddRelationDialogOpen, setIsAddRelationDialogOpen] = useState(false);
  const [addRelationType, setAddRelationType] = useState('household');

  const handleOpenAddRelationDialog = (type) => () => {
    setAddRelationType(type);
    setIsAddRelationDialogOpen(true);
  };

  const handleCloseAddRelationDialog = () => {
    setIsAddRelationDialogOpen(false);
  };

  return (
    <>
      <AddRelationDialog
        constituentId={constituent.constituentId}
        relation={addRelationType}
        open={isAddRelationDialogOpen}
        onClose={handleCloseAddRelationDialog}
      />
      {isOrg ? (
        <ConstituentRelationsList
          title={translate('DONOR_EMPLOYEES_LABEL')}
          actionLabel={translate('DONOR_ADD_EMPLOYEE_LABEL')}
          parent={constituent}
          relations={constituent.employees}
          isEditable={isEditable}
          onAddRelation={handleOpenAddRelationDialog(
            ConstituentConnectionTypes.EMPLOYEES,
          )}
          renderCardActions={(relation) => (
            <MakeConnectionPrimaryContactButton
              parent={constituent}
              relation={relation}
              className={classNames({
                'transition-opacity duration-200 hoverable:opacity-0 hoverable:group-hover:opacity-100':
                  !relation.relationData.primaryContact,
              })}
            />
          )}
        />
      ) : (
        <>
          <ConstituentRelationsList
            title={translate('DONOR_WORK_INFORMATION')}
            actionLabel={translate('DONOR_ADD_WORK_LABEL')}
            parent={constituent}
            relations={constituent.employers}
            isEditable={isEditable}
            onAddRelation={handleOpenAddRelationDialog(
              ConstituentConnectionTypes.EMPLOYERS,
            )}
          />
          <ConstituentRelationsList
            title={translate('DONOR_HOUSEHOLD_LABEL')}
            actionLabel={translate('DONOR_ADD_HOUSEHOLD_LABEL')}
            parent={constituent}
            relations={constituent.household}
            isEditable={isEditable}
            onAddRelation={handleOpenAddRelationDialog(
              ConstituentConnectionTypes.HOUSEHOLD,
            )}
          />
        </>
      )}
      <ConstituentRelationsList
        title={translate('DONOR_AFFILIATIONS_LABEL')}
        actionLabel={translate('DONOR_ADD_AFFILIATION_LABEL')}
        parent={constituent}
        relations={constituent.affiliations}
        isEditable={isEditable}
        onAddRelation={handleOpenAddRelationDialog(
          ConstituentConnectionTypes.AFFILIATIONS,
        )}
      />
      <ConstituentRelationsList
        title={translate('DONOR_CONNECTIONS_LABEL')}
        actionLabel={translate('DONOR_ADD_CONNECTION_LABEL')}
        parent={constituent}
        relations={constituent.connections}
        isEditable={isEditable}
        onAddRelation={handleOpenAddRelationDialog(
          ConstituentConnectionTypes.CONNECTIONS,
        )}
        renderCardActions={
          isOrg
            ? (relation) => (
                <MakeConnectionPrimaryContactButton
                  parent={constituent}
                  relation={relation}
                  className={classNames({
                    'transition-opacity duration-200 hoverable:opacity-0 hoverable:group-hover:opacity-100':
                      !relation.relationData.primaryContact,
                  })}
                />
              )
            : null
        }
      />
    </>
  );
}

ConstituentRelationsSection.propTypes = {
  constituent: DonorType.isRequired,
  isEditable: propTypes.bool,
};

ConstituentRelationsSection.defaultProps = {
  isEditable: false,
};

export default ConstituentRelationsSection;
